'use client';

import type { NextPage } from 'next';
import Image from 'next/image';
import { useState } from 'react';
import React from 'react';

import styles from './items-form-block1440px.module.scss';
import ButtonSimple from '../HeroBlock/components/ButtonSimple/ButtonSimple';
import TextField from './components/Text-field/Text-field';
import { ItemsFormBlock1440pxType } from '@/types/itemsFormBlock.types';

const ItemsFormBlockPromotions: NextPage<ItemsFormBlock1440pxType> = () => {
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    message: '',
    phone: '',
    membership: '',
  });

  const [errors, setErrors] = useState({
    email: '',
    name: '',
    message: '',
    phone: '',
    membership: '',
  });

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone: string) => {
    // Remove all non-digit characters for length check
    const digits = phone.replace(/\D/g, '');

    // Must have at least 10 digits (standard phone number length)
    if (digits.length < 10) {
      return false;
    }

    // Allow for international format with optional + and proper formatting
    const phoneRegex = /^\+?[\d\s-()]{10,}$/;
    return phoneRegex.test(phone);
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      email: '',
      name: '',
      message: '',
      phone: '',
      membership: '',
    };

    // Email validation
    if (!formData.email) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email';
      isValid = false;
    }

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
      isValid = false;
    }

    // Phone validation
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
      isValid = false;
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = 'Please enter a valid phone number (minimum 10 digits)';
      isValid = false;
    }

    // Membership validation
    if (!formData.membership.trim()) {
      newErrors.membership = 'Type of membership is required';
      isValid = false;
    }

    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
      isValid = false;
    } else if (formData.message.trim().length < 4) {
      newErrors.message = 'Message should be at least 4 characters';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user starts typing
    if (errors[field as keyof typeof errors]) {
      setErrors((prev) => ({
        ...prev,
        [field]: '',
      }));
    }
  };

  const handleSubmit = () => {
    if (validateForm()) {
      console.log('Form Data:', formData);
    }
  };

  return (
    <section className={styles.wrapper}>
      <div className="container">
        <div className={`${styles.formblock}`}>
          <div className={styles.leftcol}>
            <Image
              src="/img/itemsFormBlock/jet-image.webp"
              alt="jet"
              width={638}
              height={644}
              className={styles.raceTeamImage}
            />
          </div>
          <div className={styles.rightcol}>
            <h3 className={styles.interestedInSponsorship}>
              Fill in the form to be the first to know of any promotion we run
              through-out the year.
            </h3>
            <div className={styles.textFieldsWrapper}>
              <TextField
                label="Your name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('name', e.target.value)
                }
                error={errors.name}
              />
              <TextField
                label="Email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('email', e.target.value)
                }
                error={errors.email}
              />
            </div>
            <TextField
              label="Your phone"
              placeholder="Enter your phone"
              value={formData.phone}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange('phone', e.target.value)
              }
              error={errors.phone}
            />
            <TextField
              label="Type of membership"
              placeholder="Enter type of membership"
              value={formData.membership}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange('membership', e.target.value)
              }
              error={errors.membership}
            />
            <div className={styles.textField}>
              <div className={styles.label}>Your message</div>
              <textarea
                className={`${styles.row} ${errors.message ? styles.error : ''}`}
                placeholder="Enter your message (any questions or wishes)"
                rows={4}
                cols={32}
                value={formData.message}
                onChange={(e) => handleInputChange('message', e.target.value)}
              />
              {errors.message && (
                <div className={styles.errorText}>{errors.message}</div>
              )}
            </div>
            <div onClick={handleSubmit}>
              <ButtonSimple
                text="Send"
                designBlendingMode=""
                designBlendingMode1=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ItemsFormBlockPromotions;
